import { TaskStatus as IndividualTaskStatus } from '@wix/ambassador-individual-scheduling-assistant-v1-task/types';
import { isValidBase } from '../BaseEntity';
export { IndividualTaskStatus };
export const isValidIndividualTask = properties => {
  return isValidBase(properties);
};
//# sourceMappingURL=IndividualTask.js.map